import { useEffect, useState } from "react";
import { SelectFormGroup } from "~/styles/FormGroup";
import api from "~/adapters/api";
import SelectInput from "~/shared/SelectInput";

type UfSelectProps = {
    name: string;
    label?: string;
    onChange: (name: string, value: string) => void;
    ufs?: { value: string; label: string }[];
    countryId?: number;
    value?: string;
    error?: string;
    placeholder?: string;
    required?: boolean;
};

const UfSelect = ({ name, placeholder, label, onChange, ufs, countryId = 31, value, required = false, error = "" }: UfSelectProps) => {
    const [options, setOptions] = useState(ufs ?? []);

    useEffect(() => {
        if (!ufs) {
            api.location.state({ countryId }).then(states =>
                setOptions(states.entities.map(s => ({ label: s.uf, value: s.id_estados })))
            );
        }
    }, [ufs, countryId]);

    return (
        <SelectFormGroup className="form-group">
            {label ? <label htmlFor={name}>{label}{required ? " *" : ""}</label> : ""}
            <SelectInput
                placeholder={placeholder}
                name={name}
                options={options}
                onChange={onChange}
                value={value}
                required={required}
            />
            {error ? <span className="field-error small">{error}</span> : ""}
        </SelectFormGroup>
    );
};

export default UfSelect;
